import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import { DeleteDialog } from '@app/components/dialog';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { useDialog, useRequestState } from '@app/hooks';
import { deleteDesignation } from '../slice';
import { selectDeleteDesignationState } from '../selectors';
import { IDesignation } from '../types';
import { AddDesignation } from './add-designation';

interface Props {
  row: IDesignation;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const editDialog = useDialog();

  const actions = [
    {
      label: Strings.rowActions.edit,
      callback: editDialog.show,
    },
    {
      label: Strings.rowActions.delete,
      callback: deleteDialog.show,
    },
  ];
  const dispatch = useDispatch();

  const { loading } = useRequestState({
    stateSelector: selectDeleteDesignationState,
    onSuccess: deleteDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });
  const onPressDelete = () => {
    dispatch(
      deleteDesignation({
        id: row?.id,
      })
    );
  };
  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>

      <DeleteDialog
        title={`${Strings.rowActions.delete} ${Strings.designation.designation}?`}
        caption={Strings.common.deleteCaption(Strings.designation.designation)}
        deleteButtonTitle={Strings.button.confirm}
        loading={loading}
        onClose={deleteDialog.hide}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
      />

      <AddDesignation open={editDialog.visible} onClose={editDialog.hide} row={row} />
    </>
  );
};

export { RowActions };
